import { routes } from "constants/route";
import { targetStorage } from "services/hooks/useStorage";

export const logOut = () => {
  // console.log("handleLogOut");
  window.location = routes.URL_LOGIN;
  targetStorage.clear();
};
